<mat-toolbar-row *ngIf='isList'>
    <!-- <mat-form-field >
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="{{ 'inputs.search' | translate }}" #input>
      </mat-form-field> -->
    <h1 *ngIf='isList'>{{ 'titles.list.relationshipSchoolUsers' | translate }}</h1>
  
    <div fxFlex fxLayout="row" fxLayoutAlign="end center">
      <ul fxLayout="row" fxLayoutGap="20px">
        <li>
          <button mat-button (click)="newRelationship()">
            <mat-icon>add</mat-icon>
            {{ 'inputs.add_relationship' | translate }}
          </button>
        </li>
      </ul>
    </div>
  </mat-toolbar-row>
  
  
  
  
  <div class="media-body">
  
    <div *ngIf='isList'>
      <table mat-table [dataSource]="dataSource" matSort>
  
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tables.name' | translate }} </th>
          <td mat-cell *matCellDef="let element" (click)="goTo(element.id)"> {{element.user_name}} </td>
        </ng-container>
        <!-- <ng-container matColumnDef="num_list">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tables.num_list' | translate }} </th>
          <td mat-cell *matCellDef="let element" (click)="goTo(element.id)"> {{element.num_list}} </td>
        </ng-container>
  
        <ng-container matColumnDef="school">
          <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.school' | translate }} </th>
          <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" fxHide.lt-sm> {{element.school_name}}</td>
        </ng-container>
        <ng-container matColumnDef="stage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.stage' | translate }} </th>
          <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" fxHide.lt-sm>{{element.stage_name}}</td>
        </ng-container>
        <ng-container matColumnDef="grade">
          <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.grade' | translate }} </th>
          <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" fxHide.lt-sm> {{element.grade_name }} </td>
        </ng-container>
        <ng-container matColumnDef="line">
          <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.line' | translate }} </th>
          <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" fxHide.lt-sm> {{element.line_name }} </td>
        </ng-container> -->
        <!-- Action Column -->
        <ng-container matColumnDef="actions" class="actionsColumn">
          <th mat-header-cell *matHeaderCellDef> {{ 'tables.actions' | translate }} </th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button matTooltip="Click to Delete" class="iconbutton" (click)="delete(element.id)"
              color="warn">
              <mat-icon>delete</mat-icon>
            </button>
            <button mat-icon-button matTooltip="{{ 'inputs.school_report' | translate }}" class="iconbutton" (click)="sendReport(element.id)">
              <mat-icon>send</mat-icon>
            </button>
            <!-- <button mat-icon-button matTooltip="Click to reset password" class="iconbutton"
              (click)="resetPassword(element.id)">
              <mat-icon>vpn_key</mat-icon>
            </button>
              <button mat-icon-button matTooltip="{{'inputs.edit' | translate}}"
                (click)="goTo(element.id)">
                <mat-icon>edit</mat-icon>
              </button> -->
          </td>
        </ng-container>
  
  
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">
            <span *ngIf="showRelationshipsProgressBar ">{{ 'tables.loading' | translate }}</span>
            <span *ngIf="!showRelationshipsProgressBar ">{{ 'tables.no_data_found' | translate}}</span>
          </td>
        </tr>
      </table>
      <mat-progress-bar *ngIf="showRelationshipsProgressBar " mode="indeterminate"></mat-progress-bar>
      <mat-paginator [pageSizeOptions]="[100, 10, 20,50]" showFirstLastButtons></mat-paginator>
  
  
    </div>
  
  
  
  
    <div *ngIf='!isList' class="content" [formGroup]="relationshipForm">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <button (click)="goBack()" title="{{ 'inputs.back' | translate }}" mat-icon-button>
              <mat-icon>keyboard_backspace</mat-icon>
              {{ 'inputs.back' | translate }}
            </button>
            <h1 *ngIf='!isList'>{{relationship_name}}</h1>
            <div *ngIf='!isList && !isNew'>
              {{ 'inputs.creation_date' | translate }}: {{creation_date | date:'d/M/Y, H:mm:ss'}} <br>
              {{ 'inputs.modification_date' | translate }}: {{modification_date | date:'d/M/Y, H:mm:ss'}}
            </div>
  
            <div class="contenedor" [formGroup]="relationshipForm" *ngIf='!isList'>
              <input matInput [hidden]="true" [formControlName]="'id'" type="text" placeholder="id">
              
              <mat-form-field appearance="legacy">
                <mat-label>{{ 'inputs.users' | translate }}</mat-label>
                <mat-select matNativeControl [formControlName]="'users'">
                  <mat-option *ngFor="let user of users" [value]="user.id">
                    {{user.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
  
              <!-- <mat-form-field appearance="legacy">
                <mat-label>{{ 'inputs.stages' | translate }}</mat-label>
                <mat-select matNativeControl [formControlName]="'stages'" (selectionChange)="getGrades($event.value)">
                  <mat-option *ngFor="let stage of stages" [value]="stage.id">
                    {{stage.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
  
              <mat-form-field appearance="legacy">
                <mat-label>{{ 'inputs.grades' | translate }}</mat-label>
                <mat-select matNativeControl [formControlName]="'grades'" (selectionChange)="getStudents($event.value)">
                  <mat-option *ngFor="let grade of grades" [value]="grade.id">
                    {{grade.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field> -->
  
              <!-- <mat-form-field appearance="legacy">
                  <mat-label>{{ 'inputs.lines' | translate }}</mat-label>
                  <mat-select matNativeControl [formControlName]="'lines'">
                    <mat-option *ngFor="let line of lines" [value]="line.id">
                      {{line.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
              <!-- <mat-form-field appearance="legacy">
                <mat-label>{{ 'inputs.num_list' | translate }}</mat-label>
                <mat-select matNativeControl [formControlName]="'num_list'">
                  <mat-option *ngFor="let student of students" [value]="student.id">
                    {{student.num_list}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
   -->
  
  
            </div>
            <div class="float-button-container" *ngIf='!isList'>
              <button mat-fab color="primary" aria-label="save" (click)="saveRelationship($event)">
                <mat-icon>save</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="float-button-container" *ngIf='isList'>
        <button mat-fab color="primary" aria-label="add" (click)="newRelationship()">
          <mat-icon>plus_one</mat-icon>
        </button>
      </div> -->
    <div class="float-button-container" *ngIf='!isList'>
      <button mat-fab color="primary" aria-label="save" (click)="saveRelationship($event)">
        <mat-icon>save</mat-icon>
      </button>
    </div>
  </div>